<template>

<div>

  <LDBsTable
    url="group"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-12">
      <label>{{ $t('name') }}</label>
      <input 
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'GroupsList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/groups/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'grupos' }
      },
      query: {
        id: '',
        name: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = ''
    }
  }
}

</script>
